import React, { useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import {
  UserType,
  getUserTypeDisplayTextName,
} from '../../../../../../api/types/user/user-type';
import globalSettingsStores from '../../../../../../stores/settings-stores';
import { addNewDocumentRequirementOperation } from '../operations/add-new-document-requirement-operation';

interface AddNewDefaultDocumentDialogProps {
  visible: boolean;
  onHide: () => void;
}

export const AddNewDefaultDocumentDialog: React.FC<
  AddNewDefaultDocumentDialogProps
> = ({ visible, onHide }) => {
  const [loading, setLoading] = useState(false);
  const [selectedUserRole, setSelectedUserRole] = useState<UserType | null>(
    null,
  );
  const [selectedDocType, setSelectedDocType] = useState<number | null>(null);
  const [docName, setDocName] = useState('');

  const userRoleOptions = [
    {
      label: getUserTypeDisplayTextName(UserType.STUDENT),
      value: UserType.STUDENT,
    },
    {
      label: getUserTypeDisplayTextName(UserType.LECTURER),
      value: UserType.LECTURER,
    },
    {
      label: getUserTypeDisplayTextName(UserType.ADMINISTRATION),
      value: UserType.ADMINISTRATION,
    },
  ];

  const docTypeOptions = globalSettingsStores.docTypes.map((docType) => ({
    label: docType.docTypeName,
    value: docType.id,
  }));

  const handleSubmit = async () => {
    if (!selectedUserRole || !selectedDocType || !docName.trim()) {
      return;
    }

    await addNewDocumentRequirementOperation(
      selectedUserRole,
      selectedDocType,
      docName.trim(),
      setLoading,
    );

    // Reset form and close dialog
    setSelectedUserRole(null);
    setSelectedDocType(null);
    setDocName('');
    onHide();
  };

  const isFormValid = selectedUserRole && selectedDocType && docName.trim();

  const handleDialogHide = () => {
    if (!loading) {
      setSelectedUserRole(null);
      setSelectedDocType(null);
      setDocName('');
      onHide();
    }
  };

  return (
    <Dialog
      header="הוספת מסמך ברירת מחדל חדש"
      visible={visible}
      onHide={handleDialogHide}
      style={{
        width: '500px',
        backgroundColor: 'white',
        padding: '8px',
        borderRadius: '8px',
      }}
      modal
      closable={!loading}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '16px',
          padding: '16px',
        }}
      >
        <div>
          <label
            htmlFor="userRole"
            style={{
              display: 'block',
              marginBottom: '8px',
              textAlign: 'right',
            }}
          >
            תפקיד משתמש
          </label>
          <Dropdown
            id="userRole"
            value={selectedUserRole}
            options={userRoleOptions}
            onChange={(e) => setSelectedUserRole(e.value)}
            placeholder="בחר תפקיד"
            style={{ width: '100%', textAlign: 'right' }}
            disabled={loading}
          />
        </div>

        <div>
          <label
            htmlFor="docType"
            style={{
              display: 'block',
              marginBottom: '8px',
              textAlign: 'right',
            }}
          >
            סוג מסמך
          </label>
          <Dropdown
            id="docType"
            value={selectedDocType}
            options={docTypeOptions}
            onChange={(e) => setSelectedDocType(e.value)}
            placeholder="בחר סוג מסמך"
            style={{ width: '100%', textAlign: 'right' }}
            disabled={loading}
          />
        </div>

        <div>
          <label
            htmlFor="docName"
            style={{
              display: 'block',
              marginBottom: '8px',
              textAlign: 'right',
            }}
          >
            שם הקובץ
          </label>
          <InputText
            id="docName"
            value={docName}
            onChange={(e) => setDocName(e.target.value)}
            placeholder="הכנס שם קובץ"
            style={{ width: '100%', textAlign: 'right' }}
            disabled={loading}
          />
        </div>

        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            gap: '8px',
            marginTop: '16px',
          }}
        >
          <Button
            label="ביטול"
            severity="secondary"
            onClick={handleDialogHide}
            disabled={loading}
          />
          <Button
            label="אישור"
            onClick={handleSubmit}
            loading={loading}
            disabled={!isFormValid}
          />
        </div>
      </div>
    </Dialog>
  );
};
